import { createEntityAdapter, createReducer } from '@reduxjs/toolkit';

import Host from '../../../Host';
import {
  fetchSigningProgressInformation,
  fetchSigningProgressInformationSuccess,
} from '../../actions';

export const signingProgressInformationHostsAdepter = createEntityAdapter<Host>({
  selectId: (host) => host.dataLabel,
});

const initialState = signingProgressInformationHostsAdepter.getInitialState();
export const { selectEntities: selectHostsById } =
  signingProgressInformationHostsAdepter.getSelectors();

const signingProgressInformationHostSlice = createReducer(initialState, (builder) =>
  builder
    .addCase(fetchSigningProgressInformation, () => {
      return initialState;
    })
    .addCase(fetchSigningProgressInformationSuccess, (state, { payload }) => {
      signingProgressInformationHostsAdepter.setAll(state, payload.document.hosts);
    })
);

export default signingProgressInformationHostSlice;
